/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.11.20",
    versionName: "0.2.0-nightly.2025.11.20",
    versionChannel: "nightly",
    buildDate: "2025-11-20T00:07:44.126Z",
    commitHash: "e2bef0fac5fbf53517d7d4a24c60f8a14e44ee74",
};
